// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="removedHeader">Delete Property Confirmation</h1>
        </div>
        <div class="hoa-dialog__main">
            <p [hidden]="data.hasPaymentSchedules" tid="removedBodyNoSchedules">Please confirm that you
                would like to delete this property.</p>
            <p [hidden]="!data.hasPaymentSchedules" tid="removedBodyWithSchedules">
                Deleting this property will also remove any associated payment schedules. Please confirm that you
                would like to delete this property.
            <div *ngFor="let paymentSchedule of data.paymentSchedules; let i=index"
                 class="HOA-flextable-component HOA-flextable-component__cell-100 HOA-payment-schedule-hrule-last__parent">
                <div *ngIf="i<4" class="HOA-flex-component HOA-flextable-component__cell-100 u-mH4">
                    <div
                            class="HOA-payment-schedule__cell HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value"
                            tid="scheduleNickname{{i}}" id="scheduleNickname">
                        {{paymentSchedule.nickname}}
                    </div>
                </div>
            </div>
            <div [hidden]="data.paymentSchedules.length <= 4"
                 class="HOA-flextable-component HOA-flextable-component__cell-100 HOA-payment-schedule-hrule-last__parent">
                <div class="HOA-flex-component HOA-flextable-component__cell-100 u-mH4">
                    <div
                            class="HOA-payment-schedule__cell HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value">
                        <strong tid="plusSchedules">+{{data.paymentSchedules.length - 4}} additional
                            schedule<span [hidden]="data.paymentSchedules.length <= 5">s</span></strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="hoa-dialog__footer" if-overflow-x-class="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130" tid="cancelRemove"
                    (click)="closeThisDialog(0)">No
            </button>
            <button class="Button Button--blue Button--minWidth130" tid="confirmRemove"
                    (click)="closeThisDialog('Remove')">Yes
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;